import * as loginTypes from './loginTypes';
import history from 'src/store/history';
import { userRolesConfig } from 'src/helpers';
import { FPASSPAGE } from './constants';

export const requestloginInformation = () => ({
  type: loginTypes.GET_LOGIN_INFORMATION,
});

export const requestloginInformationSuccess = data => ({
  type: loginTypes.GET_LOGIN_INFORMATION_SUCCESS,
  data,
});

export const requestloginInformationFailure = error => ({
  type: loginTypes.GET_LOGIN_INFORMATION_FAILURE,
  error,
});

export const login = (stok, username, password) => ({
  type: loginTypes.POST_LOGIN_PENDING,
  stok,
  username,
  password,
});

// export const clearForgotPassword = () => ({
//   type: loginTypes.CLEAR_FORGOTPASSWORD_VALUES,
// });

export const loginSuccess = data => ({
  type: loginTypes.POST_LOGIN_SUCCESS,
  data,
});

export const loginFailure = error => ({
  type: loginTypes.POST_LOGIN_FAILURE,
  error,
});

export const forgotPassword = email => ({
  type: loginTypes.POST_FORGOT_PASSWORD_PENDING,
  email,
});

export const forgotPasswordSuccess = data => ({
  type: loginTypes.POST_FORGOT_PASSWORD_SUCCESS,
  data,
});

export const forgotPasswordFailure = error => ({
  type: loginTypes.POST_FORGOT_PASSWORD_FAILURE,
  error,
});

export const validateCodeSuccess = data => ({
  type: loginTypes.VALIDATE_CODE_SUCCESS,
  data,
});

export const validateCodeFailure = error => ({
  type: loginTypes.VALIDATE_CODE_FAILURE,
  error,
});

export const setPINCode = (code, profileKey) => ({
  type: loginTypes.VALIDATE_CODE_PENDING,
  code,
  profileKey,
});

export const clearErrors = () => ({
  type: loginTypes.CLEAR_ERRORS,
});

export const clearLoginAttempts = () => ({
  type: loginTypes.CLEAR_LOGIN_ATTEMPTS,
});

export const gotoPage = page => {
  switch (page) {
    case FPASSPAGE:
      return { type: loginTypes.GOTO_FORGOT_PASSWORD };
    default:
      return { type: loginTypes.GOTO_LOGIN };
  }
};

export const returnToLogin = () => () => history.goBack();

export const userValidateToken = () => ({
  type: loginTypes.USER_VALIDATE_TOKEN,
});

export const userValidateSuccess = data => ({
  type: loginTypes.USER_VALIDATE_SUCCESS,
  data,
});

export const resendCodePending = email => ({
  type: loginTypes.RESEND_CODE_PENDING,
  email,
});
export const resendCodeSuccess = message => ({
  type: loginTypes.RESEND_CODE_SUCCESS,
  message,
});
export const resendCodeFailure = error => ({
  type: loginTypes.RESEND_CODE_FAILURE,
  error,
});

export const resetPasswordPending = password => {
  return {
    type: loginTypes.RESET_PASSWORD_PENDING,
    password,
  };
};

export const resetPasswordSuccess = data => ({
  type: loginTypes.RESET_PASSWORD_SUCCESS,
  data,
});

export const resetPasswordFailure = error => ({
  type: loginTypes.RESET_PASSWORD_FAILURE,
  error,
});

export const validateUserPending = () => {
  return {
    type: loginTypes.VALIDATE_USER_PENDING,
  };
};

export const validateUserSuccess = data => ({
  type: loginTypes.VALIDATE_USER_SUCCESS,
  data,
});

export const validateUserFailure = error => ({
  type: loginTypes.VALIDATE_USER_FAILURE,
  error,
});

export const updateUserRoles = data => {
  const userRoles = userRolesConfig(data);

  return {
    type: loginTypes.UPDATE_USER_ROLES,
    userRoles,
  };
};

export const clearSession = () => ({
  type: loginTypes.CLEAR_SESSION,
});

export const logoutSession = () => ({
  type: loginTypes.LOGOUT_SESSION,
});

export const setUserInfoFromStorage = userData => ({
  type: loginTypes.SET_USER_FROM_SESSION,
  data: {
    ...userData,
    userRoles: userRolesConfig(userData),
    isValidated: true,
  },
});
